const AccountTypes = {
    PRIVATE_ENTITY: 1,
    LEGAL_ENTITY: 2,
    ADMIN: 3
};

export default AccountTypes;